var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eLearningYoutubeCard"},[_c('div',{staticClass:"embed-container",attrs:{"alt":`${_vm.item.title}`}},[_c('iframe',{attrs:{"src":_vm.youtubeURL,"frameborder":"0","allowfullscreen":""}})]),_c('h3',{staticClass:"eLearningYoutubeCard__title"},[_vm._v(_vm._s(_vm.item.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }